export const policyNumber = (value: string): string => {
  const alphanumeric = value.replace(/[^a-zA-Z0-9]/g, "");
  const upper = alphanumeric.toUpperCase();
  const letters = upper.match(/[A-Z]/g)?.join("") ?? "";
  const digits = upper.match(/\d/g)?.join("") ?? "";

  const normalized =
    letters.length >= 3
      ? letters.slice(0, 3) + digits.slice(0, 7)
      : letters.slice(0, 3);

  return normalized;
};
